import { Component, EventEmitter, Input, Output } from "@angular/core"
import { AudioMedia } from "../../../models/resource/media"
import { MuxDataModel } from "../../../models/muxData.model"
import { GtmVideoJsInfo } from "../../../utils/types"

@Component({
    selector: "app-audio-preview",
    templateUrl: "./audio-preview.component.html",
    styleUrls: ["./audio-preview.component.scss"],
    standalone: false,
})
export class AudioPreviewComponent {
    //TODO do we need this ?
    @Input() public audioMedia: AudioMedia
    @Input() public muxData: MuxDataModel = new MuxDataModel()
    @Input() public gtmVideoJsInfo: GtmVideoJsInfo
    @Output() public audioPreviewPlayerReady: EventEmitter<any> = new EventEmitter<any>()

    constructor() {}

    public onAudioPlayerReady(videoPlayer) {
        this.audioPreviewPlayerReady.emit(videoPlayer)
    }
}
